/**
 * `navigator.vibrate` wrapper (docs/05-ui-design.md §7). A no-op wherever vibration isn't
 * supported (desktop browsers, iOS Safari) or permitted — never throws.
 */
import { useCallback } from 'react';
import { usePreferencesStore } from '@/stores/preferences.store';

export function vibrate(ms: number, options: { enabled: boolean }): void {
  if (!options.enabled) return;
  if (typeof navigator === 'undefined' || typeof navigator.vibrate !== 'function') return;
  try {
    navigator.vibrate(ms);
  } catch {
    // unsupported or blocked — haptics are a nicety, never worth surfacing an error for
  }
}

export function useHaptics() {
  const enabled = usePreferencesStore((s) => s.haptics);
  return useCallback((ms: number) => vibrate(ms, { enabled }), [enabled]);
}
